var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoColere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon",
    transform: "translate(-704.000000, -735.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.16344416,0 0,7.16344416 0,16 C0,24.8365565 7.16344416,32 16,32 C24.8365565,32 32,24.8365565 32,16 C32,7.16344416 24.8365565,0 16,0 Z M16.0000003,29.8666673 C8.34165165,29.8666673 2.13333338,23.658349 2.13333338,16.0000003 C2.13333338,8.34165165 8.34165165,2.13333338 16.0000003,2.13333338 C23.658349,2.13333338 29.8666673,8.34165165 29.8666673,16.0000003 C29.8666673,19.6776691 28.4057191,23.2047101 25.8052146,25.8052146 C23.2047101,28.4057191 19.6776691,29.8666673 16.0000003,29.8666673 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.066667,19.2000004 C14.1211483,19.2000004 11.7333336,21.5878151 11.7333336,24.5333339 C11.7333336,25.1224376 12.2108965,25.6000006 12.8000003,25.6000006 C13.389104,25.6000006 13.866667,25.1224376 13.866667,24.5333339 C13.8650528,23.0835697 14.8383119,21.8138436 16.2387096,21.4387371 C17.6391073,21.0636305 19.1167321,21.6768699 19.8400004,22.9333338 C20.0216142,23.2805108 20.3789459,23.5001738 20.7707204,23.5054767 C21.1624949,23.5107795 21.5256411,23.3008684 21.7165849,22.9587342 C21.9075287,22.6165999 21.8955305,22.1973222 21.6853338,21.8666671 C20.7326497,20.2165699 18.9720352,19.2000004 17.066667,19.2000004 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.2000002,
    cy: 12.2666669,
    r: 1.60000003
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20.8000005,
    cy: 12.2666669,
    r: 1.60000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2800003,9.41866687 C13.595846,9.65622869 14.0171556,9.69968408 14.3748418,9.53159276 C14.732528,9.36350144 14.9679575,9.01141756 14.9866438,8.61664556 C15.0053301,8.22187355 14.8042099,7.8491259 14.4640003,7.64800017 L11.2640002,5.51466679 C10.7766681,5.22656484 10.1491548,5.3693601 9.8344723,5.8399664 C9.51978977,6.3105727 9.62756802,6.94503878 10.0800002,7.28533349 L13.2800003,9.41866687 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1333337,9.60000291 C18.3424361,9.59836733 18.5464465,9.53530954 18.7200004,9.41866687 L21.9200005,7.28533349 C22.3724327,6.94503878 22.4802109,6.3105727 22.1655284,5.8399664 C21.8508459,5.3693601 21.2233326,5.22656484 20.7360004,5.51466679 L17.5360004,7.64800017 C17.1460977,7.91001382 16.9735057,8.39626143 17.1109656,8.84546076 C17.2484255,9.29466008 17.6635741,9.60105263 18.1333337,9.60000291 Z",
    id: "Path"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoColere);
export default __webpack_public_path__ + "static/media/picto-colere.e241a42305147bb5c1e3ed44a1f8fe9e.svg";
export { ForwardRef as ReactComponent };